import { transformFromNumberToString } from 'components/modules/Insurance/Insurance.helpers';
import { FIELDS } from 'store/insuranceAnketa/constants';

export const NAMES = {
  CHANGED: 'changed',
  DATE_ISSUE: 'dateIssue',
  EXPERIENCE: 'experience',
  PREVIOUS_DATE_ISSUE: 'previousDateIssue',
  PREVIOUS_NUMBER: 'previousNumber',
  PREVIOUS_SERIES: 'previousSeries',
  SERIES_AND_NUMBER: 'seriesAndNumber',
};

export const STORE_MAP = {
  [NAMES.CHANGED]: FIELDS.DRIVING_LICENSE_IS_FIRST,
  [NAMES.DATE_ISSUE]: FIELDS.DRIVING_LICENSE_ISSUE_DATE,
  [NAMES.EXPERIENCE]: FIELDS.DRIVING_EXPERIENCE,
  [NAMES.PREVIOUS_DATE_ISSUE]: FIELDS.PREVIOUS_DRIVING_LICENSE_ISSUE_DATE,
  [NAMES.SERIES_AND_NUMBER]: FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER,
};
export const STORE_TRANSFORM = {
  [NAMES.CHANGED]: (changed) => {
    return !changed;
  },
  [NAMES.EXPERIENCE]: transformFromNumberToString,
};

export const DEFAULT_VALUES = Object.values(NAMES).reduce(
  (acc, key) => {
    acc[key] ??= '';

    return acc;
  },
  { [NAMES.CHANGED]: false }
);
